var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7,47.9l-5.3-.7h-.3L85,46.8l.2-15.3a3.7,3.7,0,0,0-.8-2.4l-4-5.5A3.8,3.8,0,0,0,77.7,22L27.8,15.7a4,4,0,0,0-2.8.7L5.7,30.2a4.5,4.5,0,0,0-1.4,1.9l-.9,2.6A3.1,3.1,0,0,0,3.1,36v5.8c0,.2.1.4.1.6V85.8A1.8,1.8,0,0,0,5,87.6H28.1a1.8,1.8,0,0,0,1.8-1.8V59l5.8.3V85.8a1.8,1.8,0,0,0,1.8,1.8h7.6a1.8,1.8,0,0,0,1.8-1.8v-26l5.7.2V85.8a1.8,1.8,0,0,0,1.9,1.8H62a1.9,1.9,0,0,0,1.9-1.8V60.5l5.7.2V85.8a1.8,1.8,0,0,0,1.8,1.8H79a1.8,1.8,0,0,0,1.8-1.8V61.2l5.1.2V85.8a1.8,1.8,0,0,0,1.8,1.8h7.6a1.8,1.8,0,0,0,1.8-1.8v-34A3.8,3.8,0,0,0,93.7,47.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.83072ad5.svg";
export { ForwardRef as ReactComponent };